import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import styles from "./ViewEvaluator.module.css";
import { R_PER_PAGE } from "../../../../../labels";
import Pagination from "../../../../ReusuableComponent/Pagination/Pagination";
import { Modal } from "react-bootstrap";
import DatePickerSample from "../../../DatePicker";
import Loader from "../../../Loader";
import { styled } from "@mui/material/styles";
import Chip from "@mui/material/Chip";
import Paper from "@mui/material/Paper";
import { AxiosInstance } from "../../../../../axios";
import moment from "moment";
import toast from "react-hot-toast";
import { customStyles } from "../../../../../pages/customStyles";
import Select from "react-select";
function ViewEvaluator() {
  const location = useLocation();
  const { EVNAME, EVID, STAFFID, BID, EVCOUNT } = location.state || {};
  let page = R_PER_PAGE;
  const [currentPage, setCurrentPage] = useState(1);
  const [isOpen, setIsOpen] = useState({
    status: false,
  });
  useEffect(() => {
    // Scroll to the top of the page when the component mounts
    window.scrollTo(0, 0);
  }, []);
  // get user id from session storage
  const userJSON = sessionStorage.getItem("userDetails");
  let userid_admin = null;

  if (userJSON) {
    const user = JSON.parse(userJSON);
    if (user && user.user_id) {
      userid_admin = user.user_id;
    }
  } else {
    console.log("User Id cannot available in session storage");
  }
  const [rowsPerPage, setRowsPerPage] = useState(page);
  const [isLoading, setIsLoading] = useState(false);
  const [sortOrder, setSortOrder] = useState("");
  const [status, setStatus] = useState([]);
  const [selectedValue, setSelectedValue] = useState("");
  const [selectedDetails, setSelectedDetails] = useState({
    id: null,
    paperType: null,
  });

  const [supVisior, setSupVisior] = useState([]);
  const [error, setError] = useState({});
  // resssign evaluvator state
  const [dropDown, setDropDown] = useState({
    evaluvator_id: "",
    staff_type: "",
    evaluvator_name: "",
    due_date: "",
    num_assign: "",
  });
  const filterRef = useRef(null);
  const txtAdMDob = useRef(null);
  const [show, setShow] = useState(false);
  const [open, setOpen] = useState(false);
  const [updateChipData, setUpdateChipData] = useState([]);
  const navigate = useNavigate();
  // chipdata listitem
  const ListItem = styled("li")(({ theme }) => ({
    margin: theme.spacing(0.5),
  }));

  useEffect(() => {
    loadListdata();
  }, [updateChipData]);
  // total table data  with pages
  const handlePrev = (newPage) => {
    if (newPage >= 1) {
      setCurrentPage(newPage);
    }
  };
  const handleNext = (newPage) => {
    if (newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  const handlePageCount = (e) => {
    setRowsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };
  // evaluvator dropdown list
  useEffect(() => {
    AxiosInstance.post("api/staff/allSupervisor")
      .then((res) => {
        if (res.data.status === true) {
          if (res.data.data.length > 0) {
            const sup = res.data.data.map((ls) => ({
              staff_type: ls.staff_type,
              label: ls.full_name,
              value: ls.id,
            }));
            setSupVisior(sup);
          }
        } else if (res.data.status === false) {
          setSupVisior([]);
        }
      })
      .catch((error) => {
        return error;
      });
  }, []);

  const [selectedStudents, setSelectedStudents] = useState([]);
  // table check box for student list
  const handleTableCheckboxChange = (
    e,
    studentUSERId,
    StudentlistID,
    bathidd
  ) => {
    const isChecked = e.target.checked;
    if (isChecked) {
      setSelectedStudents((prevState) => [
        ...prevState,
        { user_id: studentUSERId, stud_id: StudentlistID, batch_id: bathidd },
      ]);
    } else {
      setSelectedStudents((prevState) =>
        prevState.filter((id) => id.user_id !== studentUSERId)
      );
    }
  };
  const handleTableCheckboxChangeAll = (e, datas) => {
    const isChecked = e.target.checked;
    if (isChecked) {
      // Add all users to the selected students state
      const newSelectedStudents = datas
        ?.filter((df) => df.evaluated_status === 0)
        .map((ui) => ({
          user_id: ui.user_id,
          stud_id: ui.id,
          batch_id: ui.batch_id,
        }));
      setSelectedStudents(newSelectedStudents);
    } else {
      // Clear the selected students state
      setSelectedStudents([]);
    }
  };
  const start = (currentPage - 1) * rowsPerPage;
  const end = start + rowsPerPage;
  const [filteredData, setFilteredData] = useState([]);
  const [dataItem, setDataItem] = useState([]);
  const currentDatas = filteredData.slice(start, end);
  // mobile tooltip
  const totalPages = Math.ceil(filteredData?.length / rowsPerPage);

  let pressTimer;
  document.querySelectorAll(".tooltip-container").forEach((el) => {
    el.addEventListener("touchstart", function () {
      pressTimer = setTimeout(() => {
        this.classList.add("active");
      }, 500); // Long press duration
    });

    el.addEventListener("touchend", function () {
      clearTimeout(pressTimer);
      this.classList.remove("active");
    });
  });

  // filter box open and close functionality
  const handleFilter = (e, boxName) => {
    if (boxName === "evaluationStatus") {
      setIsOpen((prevState) => ({
        status: !prevState.status,
      }));
      setStatus(updateChipData.filter((ui) => ui.type === "status"));
    }
  };

  //chips overall clear button
  const handleAllClear = () => {
    setStatus([]);
    setUpdateChipData([]);
    setFilteredData([]);
  };

  //chips delete button
  const handleDelete = (chipToDelete, index) => () => {
    updateStateData();
    if (chipToDelete.type === "status") {
      setStatus(status.filter((item) => item.id !== chipToDelete.id));
      filterStatus = status.filter((item) => item.id !== chipToDelete.id);
    }
    loadChipdata();
  };
  // filter checkbox checked
  const handleCheckboxChange = (event) => {
    const { name, value, checked } = event.target;
    setStatus((prevStatus) => {
      if (checked) {
        return [...prevStatus, { id: value, name: name, type: "status" }];
      } else {
        return prevStatus.filter((item) => item.id !== value);
      }
    });
  };
  // clear in filter box
  const handleClear = (name) => {
    if (name === "evaluationStatus") {
      setStatus([]);
      setIsOpen({ ...isOpen, status: false });
    }
  };
  // close the popu when mouse click outside
  const handleClickOutside = (event) => {
    const isChipData = event.target.closest(".paperil_global");
    if (
      filterRef.current &&
      !filterRef.current.contains(event.target) &&
      !isChipData
    ) {
      if (!isOpen.status && status.length === 0) {
        setIsOpen((prevState) => ({ ...prevState, status: false }));
      }
      // Only reset isFiltered if the filter dropdown is closed
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  let filterStatus = [];

  useEffect(() => {
    filterStatus = status;
  }, [status]);

  function updateStateData() {
    filterStatus = status;
  }
  // load table data based on filter
  function loadListdata() {
    let typeStatus = [];
    status.map((obj) => {
      typeStatus.push(obj.id);
    });
    let statusFilter = {
      staff_id: STAFFID,
      event_id: EVID, // event give from admin side list faculty side give as empty
      // add_more_status: ADMORST, // faculty side default as 0
      add_more_status: 0, // faculty side default as 0
      status:
        typeStatus.length > 0 && typeStatus.length < 2 ? typeStatus[0] : "",
    };
    setIsLoading(true);
    AxiosInstance.post("api/test/descriptive/stud_list", statusFilter)
      .then((res) => {
        if (res.data.status === true) {
          setIsLoading(false);
          const fiata = res.data.data.stud_data;
          const serialNumberAddedData = fiata.map((data, index) => ({
            ...data,
            serialNumber: index + 1,
          }));
          setFilteredData(serialNumberAddedData);
          const assign_status_data = res.data.data.assign_staus
            ? res.data.data.assign_staus
            : [];
          setDataItem(assign_status_data);
        } else if (res.data.status === false) {
          setIsLoading(false);
          setFilteredData([]);
          setDataItem([]);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        setFilteredData([]);
        setDataItem([]);
        return error;
      });
  }
  // update chipdata functionality
  function loadChipdata() {
    let tempArr = [];
    filterStatus.map((obj) => {
      tempArr.push(obj);
    });
    setUpdateChipData(tempArr);
  }
  // handle apply filter
  const handleApplyFilter = (name) => {
    updateStateData();
    if (name === "evaluationStatus") {
      loadChipdata();
      setIsOpen({ ...isOpen, status: false });
    }
  };
  // sorting functionality
  const handleSort = (event, sortKey) => {
    event.preventDefault();
    let order = sortOrder === "asc" ? "desc" : "asc";
    setSortOrder(order);
    let sortedList = [...filteredData].sort((a, b) => {
      // Convert both strings to lowercase to ensure case-insensitive comparison
      let aValue = a[sortKey]?.toString().toLowerCase();
      let bValue = b[sortKey]?.toString().toLowerCase();
      if (sortKey === "sNo") {
        aValue = Number(aValue);
        bValue = Number(bValue);
      }
      if (aValue < bValue) {
        return order === "asc" ? -1 : 1;
      }

      if (aValue > bValue) {
        return order === "asc" ? 1 : -1;
      }
      if (aValue == bValue) {
        return order === "asc" ? 1 : -1;
      }
      return 0;
    });

    setFilteredData(sortedList);
  };
  const handleClose = () => {
    setShow(false);
    setError({});
    setDropDown({
      evaluvator_id: "",
      staff_type: "",
      evaluvator_name: "",
      due_date: "",
      num_assign: "",
    });
  };
  const handleShow = () => setShow(true);
  const handleOpen = () => setOpen(true);
  const handleModelClose = () => {
    setOpen(false);
    setError({});
    setDropDown({
      evaluvator_id: "",
      staff_type: "",
      evaluvator_name: "",
      due_date: "",
      num_assign: "",
    });
  };
  // navigate to previous screen
  const navigateToPreviousScreen = () => {
    navigate(-1); // Navigate back by one step in the history
  };

  // unassign student
  const handleUnAssignRequest = () => {
    const bb = selectedStudents.map((io) => ({
      user_id: io.user_id,
      stud_list_id: io.stud_id,
    }));
    let unstu = {
      staff_id: STAFFID,
      event_id: EVID,
      batch_id: parseInt(BID),
      evaluator_count: EVCOUNT,
      created_by: userid_admin,
      created_date: moment().format("YYYY-MM-DD HH:mm:ss"),
      unassing_count: selectedStudents.length,
      student_details: bb,
    };

    AxiosInstance.post("api/test/descriptive/unassign_byadmin", unstu)
      .then((res) => {
        if (res.data.status === true) {
          toast.success(res.data.message);
          loadListdata();
          setSelectedStudents([]);
          handleClose();
        } else if (res.data.status === false) {
          toast.error(res.data.message);
        }
      })
      .catch((error) => {
        return error;
      });
  };

  const validaReassign = (data) => {
    const errors = {};
    if (data.evaluvator_id === "") {
      errors.evaluvator_name = "Please select an evaluator";
    }
    if (data.due_date === "") {
      errors.due_date = "Please select an due date";
    }
    return errors;
  };
  // assign student
  const handlereAssignRequest = () => {
    const errors = validaReassign(dropDown);
    if (Object.keys(errors).length === 0) {
      const bb_re = selectedStudents.map((io) => ({
        user_id: io.user_id,
        stud_list_id: io.stud_id,
        batch_id: io.batch_id,
      }));
      let Assinstu = {
        reassign_staff_id: dropDown.evaluvator_id ? dropDown.evaluvator_id : "",
        due_date: dropDown.due_date ? dropDown.due_date : "",
        staff_id: STAFFID,
        event_id: EVID,
        batch_id: parseInt(BID),
        evaluator_count: EVCOUNT,
        created_by: userid_admin,
        created_date: moment().format("YYYY-MM-DD HH:mm:ss"),
        assign_count: selectedStudents.length,
        student_details: bb_re,
      };
      AxiosInstance.post("api/test/descriptive/reassign", Assinstu)
        .then((res) => {
          if (res.data.status === true) {
            toast.success(res.data.message);
            loadListdata();
            handleModelClose();
            setSelectedStudents([]);
          } else if (res.data.status === false) {
            // toast.error(res.data.message);
            setError({
              ...error,
              evaluvator_name: res.data.message,
            });
            setDropDown({
              evaluvator_id: "",
              staff_type: "",
              evaluvator_name: "",
              due_date: "",
              num_assign: "",
            });
          }
        })
        .catch((error) => {
          return error;
        });
    } else {
      setError(errors);
    }
  };

  // grouping the evaluvator dropdown
  const groupedSupervisors = supVisior.reduce((acc, supervisor) => {
    const type = supervisor.staff_type;
    if (!acc[type]) acc[type] = [];
    acc[type].push(supervisor);
    return acc;
  }, {});
  const groupedOptions = Object.keys(groupedSupervisors).map((type) => ({
    label: type === "0" ? "Faculty" : type === "1" ? "Staff" : "Panel Member",
    options: groupedSupervisors[type].map((sup) => ({
      staff_type: sup.staff_type,
      value: sup.value,
      label: sup.label,
    })),
  }));

  // evaluvator reassign  onchange
  const handleEvaluvatorChange = (opm) => {
    if (opm) {
      if (opm.value !== STAFFID) {
        setDropDown((prevState) => ({
          ...prevState,
          ["staff_type"]: opm.staff_type,
          ["evaluvator_id"]: opm.value,
          ["evaluvator_name"]: opm.label,
        }));
        setError(() => ({
          ...error,
          ["evaluvator_name"]: "",
        }));
        handleallEva(opm.value);
      } else {
        setDropDown((prevState) => ({
          ...prevState,
          ["staff_type"]: "",
          ["evaluvator_id"]: "",
          ["evaluvator_name"]: "",
          ["due_date"]: "",
        }));
        setError(() => ({
          ...error,
          ["evaluvator_name"]: "Please select another evaluator",
        }));
      }
    } else {
      setDropDown((prevState) => ({
        ...prevState,
        ["staff_type"]: "",
        ["evaluvator_id"]: "",
        ["evaluvator_name"]: "",
        ["due_date"]: "",
      }));
      setError(() => ({
        ...error,
        ["evaluvator_name"]: "",
      }));
    }
  };

  // evaluvator dropdown functionality update

  const handleallEva = (stID) => {
    AxiosInstance.post("api/staff/allEvaluator", {
      staff_id: stID,
      event_id: EVID,
    })
      .then((res) => {
        if (res.data.status === true) {
          if (res.data.data.length > 0) {
            setDropDown((prevState) => ({
              ...prevState,
              ["num_assign"]: res.data.data[0].total_assigned_students,
              ["due_date"]: res.data.data[0].due_date,
            }));
          } else {
            setDropDown((prevState) => ({
              ...prevState,
              ["num_assign"]: "",
              ["due_date"]: "",
            }));
          }
        } else if (res.data.status === false) {
          setDropDown((prevState) => ({
            ...prevState,
            ["num_assign"]: "",
            ["due_date"]: "",
          }));
        }
      })
      .catch((error) => {
        return error;
      });
  };

  const handleReadView = (eventIDss, UserIdss, EVCOUNTS) => {
    navigate("/AdminViewStudent/1", {
      state: {
        EVENTID: eventIDss,
        USER_ID: UserIdss,
        EVCOUNTS: EVCOUNTS,
      },
    });
  };

  const handleChangeDates = (date, name) => {
    const dateDOB = moment(date).format("YYYY-MM-DD");
    setDropDown({
      ...dropDown,
      [name]: dateDOB,
    });
    setError({
      ...error,
      [name]: "",
    });
  };

  return isLoading ? (
    <div
      className="loaderApi"
      style={{
        display: isLoading ? "flex" : "none",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "white",
        zIndex: 999,
      }}
    >
      {isLoading && <Loader />}
    </div>
  ) : (
    <>
      <div
        className={`${styles.ViewEvaluatorMain} global_container container-fluid BathHeader`}
      >
        <div className="row ">
          <div className=" col-md-6 col-12 ">
            <h6 className="TitleHeader "> View Evaluator - {EVNAME}</h6>
          </div>
          <div className="col-md-6 col-12 ListBtn">
            <ul class="List-Button">
              <li class="ListBtnItems">
                <Link
                  to={`javascript:void(0)`}
                  onClick={navigateToPreviousScreen}
                  className="secondaryButton "
                >
                  Back to View Test
                </Link>
              </li>
              <li class="ListBtnItems">
                <Link
                  onClick={() => {
                    if (selectedStudents.length > 0) {
                      handleShow();
                    }
                  }}
                  to="javascript:void(0)"
                  className={`primaryButton ${
                    selectedStudents.length === 0 ? "disabledbtn" : ""
                  }`}
                  style={{
                    pointerEvents:
                      selectedStudents.length === 0
                        ? "none disabledbtn"
                        : "auto",
                  }}
                >
                  Unassign Students
                </Link>
              </li>
              <li class="ListBtnItems">
                <Link
                  onClick={() => {
                    if (selectedStudents.length > 0) {
                      handleOpen();
                    }
                  }}
                  // disabled={selectedStudents.length === 0 ? true : false}
                  to={"javascript:void(0)"}
                  className={`primaryButton ${
                    selectedStudents.length === 0 ? "disabledbtn" : ""
                  }`}
                  style={{
                    pointerEvents:
                      selectedStudents.length === 0
                        ? "none disabledbtn"
                        : "auto",
                  }}
                >
                  Reassign to Another Evaluator
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="">
          <fieldset className="mt-3">
            <legend className="w-auto">Student List</legend>
            {/* chipdata related code  */}
            {updateChipData.length > 0 ? (
              <div className="row mt-3">
                <div className="col-md-12 col-sm-12 col-xs-12 paperil_global">
                  <Paper
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      flexWrap: "wrap",
                      listStyle: "none",
                      p: 0.5,
                      m: 0,
                    }}
                    component="ul"
                  >
                    {updateChipData.map((data, index) => {
                      let icon;
                      let key = "" + data.name;
                      return (
                        <ListItem key={data}>
                          <Chip
                            icon={icon}
                            label={key}
                            onDelete={handleDelete(data, index)}
                          />
                        </ListItem>
                      );
                    })}
                    <ListItem className="clearAll_list">
                      <a
                        className={"clearAll_listItem"}
                        href="javascript:void(0)"
                        onClick={handleAllClear}
                      >
                        Clear All Filters
                      </a>
                    </ListItem>
                  </Paper>
                </div>
              </div>
            ) : (
              <div></div>
            )}
            <div className="row mx-0">
              <div className="col-md-12  table-responsive tableMinHeight mt-2 px-0">
                <table className="table" id="tableListHeader">
                  <thead>
                    <tr>
                      <th id="th" style={{ width: "5% !important" }}>
                        <input
                          type="checkbox"
                          onChange={(e) =>
                            handleTableCheckboxChangeAll(e, currentDatas)
                          }
                          className={`${
                            currentDatas?.some(
                              (io) => io.evaluated_status !== 0
                            ) || currentDatas?.length === 0
                              ? "ListCheckbox align-text-bottom disabled_btn"
                              : "ListCheckbox align-text-bottom"
                          }`}
                          checked={
                            selectedStudents?.length > 0 &&
                            selectedStudents?.length === currentDatas?.length
                              ? true
                              : false
                          }
                          disabled={
                            currentDatas?.some(
                              (io) => io.evaluated_status !== 0
                            ) || currentDatas?.length === 0
                          }
                        />
                      </th>
                      <th id="th">
                        <span className="textHead_th">Name</span>
                        <span
                          className={`textHead_th material-icons align-middle`}
                          onClick={(e) => handleSort(e, "fullname")}
                        >
                          import_export
                        </span>
                      </th>
                      <th id="th">
                        <span className="textHead_th">Admission ID</span>
                        <span
                          className={`textHead_th material-icons align-middle`}
                          onClick={(e) => handleSort(e, "admissionID")}
                        >
                          import_export
                        </span>
                      </th>
                      <th id="th">
                        <span className="textHead_th "> Email ID</span>
                        <span
                          className={`textHead_th material-icons align-middle`}
                          onClick={(e) => handleSort(e, "email")}
                        >
                          import_export
                        </span>
                      </th>
                      <th id="th">
                        <span className="textHead_th">Phone Number</span>
                        <span
                          className={`textHead_th material-icons align-middle`}
                          onClick={(e) => handleSort(e, "phone_no")}
                        >
                          import_export
                        </span>
                      </th>
                      <th id="th" ref={filterRef}>
                        <span className="textHead_th">Evaluator Status</span>
                        <span
                          className={`textHead_th material-icons align-middle`}
                          onClick={(e) => handleSort(e, "evaluationStatus")}
                        >
                          import_export
                        </span>
                        <span
                          className={`textHead_th align-middle material-icons ${
                            status.length > 0 ? styles.active_icons : ""
                          } ${isOpen.status ? styles.active_icons : ""}`} // Change here
                          onClick={(e) => handleFilter(e, "evaluationStatus")}
                        >
                          filter_list
                        </span>

                        {isOpen.status === true && (
                          <div className="filterBoxs_testlist">
                            <div className="col-md-12 form-check filterStatus_list">
                              <ul className="ulFilterListData">
                                <li className="filterListData">
                                  <input
                                    type="checkbox"
                                    className="ListCheckbox"
                                    name="NotYetEvaluated"
                                    value="0"
                                    id="NotYetEvaluated"
                                    checked={status.some(
                                      (element) => element.id === "0"
                                    )}
                                    onChange={handleCheckboxChange}
                                  />
                                  <label
                                    className="form-check-label filterChipText bg-pink"
                                    htmlFor="NotYetEvaluated"
                                  >
                                    Not Yet Evaluated
                                  </label>
                                </li>
                                <li className="filterListData">
                                  <input
                                    type="checkbox"
                                    className="ListCheckbox"
                                    name="Evaluated"
                                    value="1"
                                    id="Evaluated"
                                    checked={status.some(
                                      (element) => element.id === "1"
                                    )}
                                    onChange={handleCheckboxChange}
                                  />
                                  <label
                                    className="bg-green filterChipText form-check-label"
                                    htmlFor="Evaluated"
                                  >
                                    Evaluated
                                  </label>
                                </li>
                              </ul>
                            </div>
                            <div className="borderWidth row">
                              <ul className="List-Button">
                                <li className="ListBtnItems">
                                  <Link
                                    to={"javascript:void(0)"}
                                    onClick={() =>
                                      handleClear("evaluationStatus")
                                    }
                                    className="secondaryButton ms-2"
                                  >
                                    Clear
                                  </Link>
                                </li>
                                <li className="ListBtnItems">
                                  <Link
                                    to={"javascript:void(0)"}
                                    onClick={() =>
                                      handleApplyFilter("evaluationStatus")
                                    }
                                    className="primaryButton"
                                  >
                                    Apply Filter
                                  </Link>
                                </li>
                              </ul>
                            </div>
                          </div>
                        )}
                      </th>
                      <th id="th">
                        <span className="textHead_th"> Action</span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentDatas && currentDatas.length === 0 ? (
                      <tr>
                        <td
                          colSpan="15"
                          style={{
                            textAlign: "center",
                            borderBottom: "1px solid #dee2e6",
                          }}
                        >
                          No records to display
                        </td>
                      </tr>
                    ) : (
                      currentDatas.map((course, index) => (
                        <tr className={styles.rowHover} key={index}>
                          <td id={`${styles.td}`}>
                            <input
                              type="checkbox"
                              className={`${
                                course.evaluated_status !== 0
                                  ? "ListCheckbox disabled_btn"
                                  : "ListCheckbox"
                              }`}
                              disabled={
                                course.evaluated_status !== 0 ? true : false
                              }
                              checked={
                                selectedStudents.some(
                                  (iop) => iop.user_id === course.user_id
                                )
                                  ? true
                                  : false
                              }
                              onChange={(e) =>
                                handleTableCheckboxChange(
                                  e,
                                  course.user_id,
                                  course.id,
                                  course.batch_id
                                )
                              }
                            />
                          </td>
                          <td id={`${styles.td}`}>{course.fullname}</td>
                          <td id={`${styles.td}`}>{course.admissionID}</td>
                          <td
                            className="ellipsis"
                            title={course.email}
                            id={`${styles.td}`}
                          >
                            {course.email}
                          </td>
                          <td id={`${styles.td}`}>{course.phone_no}</td>

                          {course.evaluated_status === 0 && (
                            <td id={`${styles.td}`}>
                              <span className="bg-pink filterChipText">
                                Not Yet Evaluated
                              </span>
                            </td>
                          )}
                          {course.evaluated_status !== 0 && (
                            <td id={`${styles.td}`}>
                              <span className="bg-green filterChipText">
                                Evaluated
                              </span>
                            </td>
                          )}
                          <td id={`${styles.td}`}>
                            <button
                              onClick={() =>
                                handleReadView(
                                  course.event_id,
                                  course.user_id,
                                  course.evaluator_count
                                )
                              }
                              className={`view_icon_button d-flex`}
                            >
                              <span className={` visibleicon material-icons`}>
                                visibility
                              </span>
                            </button>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="row mt-2">
              <Pagination
                rowsPerPage={rowsPerPage}
                handlePageCount={handlePageCount}
                startPage={
                  filteredData && filteredData?.length > 0
                    ? currentPage * rowsPerPage + 1 - rowsPerPage
                    : 0
                }
                endPage={
                  filteredData && filteredData?.length > 0
                    ? filteredData?.length < currentPage * rowsPerPage
                      ? filteredData?.length
                      : currentPage * rowsPerPage
                    : 0
                }
                totalRecords={
                  filteredData && filteredData?.length > 0
                    ? filteredData?.length
                    : 0
                }
                handlePrev={(e) => handlePrev(currentPage - 1)}
                currentPrevPage={currentPage === 1}
                prevButton={`${styles.prev_buttonViewEvaluator} ${styles.materialIconsRightAndLeft} me-2`}
                handleNext={() => handleNext(currentPage + 1)}
                currentNextPage={currentPage === totalPages}
              />
            </div>
          </fieldset>
        </div>
        {/* Unassign Requests */}
        {dataItem.length > 0 &&
          (dataItem[0].assign_count > 0 || dataItem[0].unassign_count > 0) && (
            <div className="row m-0">
              <fieldset className="mt-3">
                <legend className="w-auto">
                  {dataItem[0].assign_count > 0
                    ? "Assign Requests"
                    : "Unassign Requests"}
                </legend>
                <div className="row mb-3">
                  <div className="my-1 col-lg-3 col-md-3 col-12">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0 p-0">
                        Number of students you want to{" "}
                        {dataItem[0].assign_count > 0 ? "assign" : "unassign"}
                      </p>
                      <p className="confirm_value my-1 m-0 p-0">
                        {dataItem[0].assign_count > 0
                          ? dataItem[0].assign_count
                            ? dataItem[0].assign_count
                            : "_"
                          : dataItem[0].unassign_count
                          ? dataItem[0].unassign_count
                          : "_"}
                      </p>
                    </div>
                  </div>
                  <div className="my-1 col-lg-3 col-md-3 col-12">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0 p-0">Status</p>
                      <p className="confirm_value my-1 m-0 p-0">
                        {" "}
                        {dataItem[0].assign_count > 0
                          ? dataItem[0].assign_count_status === 0
                            ? "Pending"
                            : `Assigned (${dataItem[0].assign_count} Students)`
                          : dataItem[0].unassign_count_status === 0
                          ? "Pending"
                          : `Unassigned (${dataItem[0].unassign_count} Students)`}
                      </p>
                    </div>
                  </div>
                </div>
              </fieldset>
            </div>
          )}
        <div>
          <>
            <Modal show={show} onHide={handleClose} size="lg" centered>
              <Modal.Header closeButton>
                <Modal.Title>
                  <h5 className="mb-0 ModalHeader "> Unassign Students </h5>
                </Modal.Title>
              </Modal.Header>
              <Modal.Body className="ModalBodyHeight">
                Are you sure you want to unassign the students?
              </Modal.Body>
              <Modal.Footer>
                <ul class="List-Button">
                  <li class="ListBtnItems">
                    <Link
                      onClick={handleClose}
                      to={"javascript:void(0)"}
                      className="secondaryButton "
                    >
                      Back to View Evaluator
                    </Link>
                  </li>
                  <li class="ListBtnItems">
                    <Link
                      onClick={handleUnAssignRequest}
                      to={"javascript:void(0)"}
                      className="primaryButton "
                      variant="primary"
                    >
                      Unassign Now
                    </Link>
                  </li>
                </ul>
              </Modal.Footer>
            </Modal>
          </>
        </div>
        <div>
          <Modal show={open} onHide={handleModelClose} size="xl" centered>
            <Modal.Header closeButton>
              <Modal.Title>
                <h5 className="mb-0 ModalHeader">
                  Reassign to Another Evaluator{" "}
                </h5>
              </Modal.Title>
            </Modal.Header>
            <Modal.Body className="ModalBodyHeight global_container">
              <div className="row">
                <div className="col-md-4">
                  <label className="confirm_value mb-2">Evaluator Name</label>
                  <Select
                    className="shadow-none input-font-size"
                    placeholder="Select Evaluator Name"
                    isClearable
                    name="evaluatorName"
                    value={
                      dropDown.evaluvator_id
                        ? {
                            label: dropDown.evaluvator_name,
                            value: dropDown.evaluvator_id,
                            staff_type: dropDown.staff_type,
                          }
                        : ""
                    }
                    options={groupedOptions}
                    styles={customStyles}
                    onChange={(option) => handleEvaluvatorChange(option)}
                  />
                  {error.evaluvator_name && (
                    <small className="error_message">
                      {error.evaluvator_name}
                    </small>
                  )}
                </div>
                <div className="col-md-4">
                  <div>
                    <label className="confirm_value mb-2">Due Date</label>
                    <DatePickerSample
                      class={`Inputs`}
                      minDate={
                        new Date(new Date().setDate(new Date().getDate() + 1))
                      } // Minimum date is tomorrow
                      datePickerInputIcon="datePickerInputIcon"
                      datePickerInput="datePickerInput"
                      txtAdMDob={txtAdMDob}
                      name={"due_date"}
                      styles={{
                        position: "relative",
                        top: "5px",
                        cursor: "pointer",
                        right: "25px",
                        color: "var(--bluebrand)",
                        opacity: 1,
                        fontSize: "22px",
                      }}
                      className={`shadow-none input-font-size `}
                      leftStyles={{
                        margin: "10px",
                        display: "flex",
                        justifyContent: "center",
                      }}
                      handleChange={handleChangeDates}
                      fieldInput={
                        dropDown.due_date
                          ? moment(dropDown.due_date).format("DD-MM-YYYY")
                          : ""
                      }
                    />
                    {error.due_date && (
                      <small className="error_message">{error.due_date}</small>
                    )}
                  </div>
                </div>
                <div className="col-md-4">
                  <div>
                    <label className="confirm_label mb-2">
                      {" "}
                      Number of Answer Sheets Assigned Already
                    </label>
                  </div>
                  <div>
                    <label className="confirm_value font_size_sixteen">
                      {" "}
                      {dropDown.num_assign ? dropDown.num_assign : "_"}
                    </label>
                  </div>
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <ul class="List-Button">
                <li class="ListBtnItems">
                  <Link
                    onClick={handleModelClose}
                    to={"javascript:void(0)"}
                    className="secondaryButton "
                  >
                    Back to View Evaluator
                  </Link>
                </li>
                <li class="ListBtnItems">
                  <Link
                    onClick={handlereAssignRequest}
                    to={"javascript:void(0)"}
                    className="primaryButton "
                    variant="primary"
                  >
                    Assign Now
                  </Link>
                </li>
              </ul>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    </>
  );
}
export default ViewEvaluator;
